import { useQuery } from '@tanstack/react-query';
import axios from '../../axiosConfig';
import { GET_CODE_DIFFERENCES_LIST } from '../queries/GetCodeItemsList';

const fetchCodeSplitData = async ({ queryKey }) => {
    const [, { token, item, handleShowMessage }] = queryKey;

    if (!token || item.length === 0) throw new Error('Token not available');
    
    try {
        const response = await axios.get(
            `/getCodeStringComparison?esoiNumber=${encodeURIComponent(item[0].esoi)}&PCL=${encodeURIComponent(item[0].pcl)}&codeString1=${encodeURIComponent(item[0].code)}&codeString2=${encodeURIComponent(item[1].code)}`,
            {
                headers: {
                    Authorization: token,
                },
            }
        );

        return {
            splitCodes: [
                response.data.codeStringSplitWhole1,
                response.data.codeStringSplitWhole2
            ],
            differences: [
                response.data.codeDifferences1,
                response.data.codeDifferences2
            ],
        };

    } catch (error) {
        handleShowMessage(error);
    }
};

export const useCodeSplit = ({ token, item}) => {
    return useQuery({
        queryKey: [GET_CODE_DIFFERENCES_LIST, { token, item }],
        queryFn: fetchCodeSplitData,
        enabled: !!token && item.length > 0,
        retry: false,
    });
};
